module.exports = __webpack_public_path__ + "static/media/wizualizacja-44.34b423aa.png";